import { MyConfirmInvitation } from './myConfirmInvitation';

require('./myConfirmInvitation.scss');

export const myConfirmInvitationComponent = {
  template: require('./myConfirmInvitation.html'),
  controllerAs: 'ctrl',
  controller: MyConfirmInvitation,
};
